import { IonButtons, IonCard, IonContent, IonHeader, IonIcon, IonLabel, IonList, IonMenuButton, IonPage, IonTitle, IonToolbar, useIonViewWillEnter, IonButton, IonItemDivider, IonRow, IonCol, IonLoading, useIonViewDidEnter } from '@ionic/react';
import { logOut, person } from 'ionicons/icons';
import React, { useContext } from 'react';
import './Home.css';
import { menuController } from '@ionic/core';
import userService from '../../resources/Authentication/userServices';
import { AuthContext } from '../../contexts/AuthContext';
import AccountSummary from '../../components/AccountSummary';
import { ConfigContext } from '../../contexts/ConfigContext';
import SalesGraph from '../Graphs/SalesGraph';
import QuickLinks from './QuickLinks';
import { APPLINKS } from '../../resources/AppConst';
import Time from '../../components/Time';

const Dashboard = ({ history }) => {
  const { getData } = useContext(ConfigContext)
  const Auth = useContext(AuthContext)

  useIonViewWillEnter(() => {
    menuController.enable(true, 'mainmenu')
    let user = JSON.parse(sessionStorage.getItem('user'))
    Auth.setUser(user)
  })

  useIonViewDidEnter(() => {
    // getData()
    console.log(window.navigator.platform);
  })

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>DashBoard</IonTitle>
          <IonButtons slot='end'>
            <IonButton onClick={() => {
              userService.logout();
              Auth.setUser({})
              history.replace(APPLINKS.login)
            }} >
              <IonIcon icon={logOut}></IonIcon>
              <IonLabel>Log Out</IonLabel>
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent class='ion-padding'>
        <IonRow class='ion-justify-content-center'>
          <IonCol size-md='9' size-sm class='ion-align-self-center'>
            <IonCard>
              <IonIcon icon={person} class='size center'></IonIcon>
              <IonItemDivider>
                <h4 className='center'>Welcome {Auth.User.firstName + ' ' + Auth.User.lastName}</h4>
              </IonItemDivider>
              <Time />
              <QuickLinks />
            </IonCard>
            <SalesGraph />
            <AccountSummary />
          </IonCol>
        </IonRow>



        <IonList lines="none">

        </IonList>

        <IonLoading />
      </IonContent>
    </IonPage>
  );
};

export default Dashboard;
